import { render, staticRenderFns } from "./levelConfig.vue?vue&type=template&id=05de2bb1&scoped=true"
import script from "./levelConfig.vue?vue&type=script&lang=js"
export * from "./levelConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05de2bb1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05de2bb1')) {
      api.createRecord('05de2bb1', component.options)
    } else {
      api.reload('05de2bb1', component.options)
    }
    module.hot.accept("./levelConfig.vue?vue&type=template&id=05de2bb1&scoped=true", function () {
      api.rerender('05de2bb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/level/levelConfig.vue"
export default component.exports